import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { LoginContext } from '../Contexts/LoginContext';
import AdminLayout from '../Layouts/AdminLayout';
import MobileRestricted from '../Components/utils/MobileRestricted';
import SEO from '../Components/utils/SEO';

const AdminProtectedRoute = ({ children }) => {

    const { isAdminLogin, admin, isTabletPro } = useContext(LoginContext);

    const location = useLocation();

    if (isTabletPro) return <MobileRestricted />;

    if (isAdminLogin === null) return null;

    if (!isAdminLogin) return <Navigate to="/chwi-admin/login" replace />;

    const normalizePageName = (path) => {
        const pageMap = {
            emails: 'Emails',
            terms: 'Terms & Conditions',
            social: 'Social Links',
            faq: 'Information Center'
        };

        const basePath = path.replace('/chwi-admin/', '').split('/')[0];

        return pageMap[basePath] || basePath.split('-').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    };

    const hasAccess = (path) => {
        if (admin?.role === 'Super Admin') return true;

        if (admin?.role === 'Admin') return path !== '/chwi-admin/employees';

        if (admin?.role === 'Moderator') {
            const page = normalizePageName(path);
            return admin?.access[page] !== undefined;
        }

        return false;
    };

    if (!hasAccess(location.pathname)) {
        const defaultPage = admin?.access ? (Object.keys(admin?.access)[0]?.toLowerCase()) : 'dashboard';
        return <Navigate to={`/chwi-admin/${defaultPage}`} replace />;
    }

    return (
        <>
            <SEO title="Admin" description="Chocowi admin" noIndex noFollow />
            <AdminLayout>{children}</AdminLayout>
        </>
    );
};

export default AdminProtectedRoute;